<mat-card [class]="listItemClass()">
  <ng-content />
</mat-card>
